import { Typography } from "@material-ui/core";
export function ProphylacticText(renalImpairmentLevel, overWeightLimit, weight) {
    let text = [];
    if (overWeightLimit) {
        text.push([<Typography variant="body2">
            <p>
                Seek consultant advice for appropriate dose in this population.
            </p>
            </Typography>]);
    } else {
        text.push([<Typography variant="body1">
                    <strong>
                    ENOXAPARIN <br />
                    PROPHYLATIC DOSE{" "}
                    </strong>
                </Typography>,
                <Typography variant="h5" color="primary">
                    {(weight > 50 && renalImpairmentLevel != 'severe') ? "40mg" : "20mg"} ONCE DAILY
                </Typography>,
                <Typography variant="body1" style={{ marginTop: 20 }}>
                <p>Use chemoprophylaxis according to VTE risk.</p>
                </Typography>,
                <Typography variant="body1" style={{ marginTop: 20 }}>
                <p><a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0035/2397554/002897.pdf">Refer to VTE guidelines.</a></p>
                </Typography>,
                <Typography variant="body1" style={{ marginTop: 20 }}>
                <strong>ENOXAPARIN MONITORING</strong>
                </Typography>,
                <Typography variant="body2">
                <p>
                    Routine monitoring of anti-factor Xa is not recommended for patients
                    on enoxaparin prophylaxis.{" "}
                </p>
                <p>
                    If any significant bleeding occurs, enoxaparin should be stopped and
                    urgent consultant review organised. Anti-factor Xa measurement may
                    assist with management.
                </p>
                </Typography>]);
    }
    return text;
}